import type { NotificationListResponseNotificationsItemBasicInfoAllOf } from './notificationListResponseNotificationsItemBasicInfoAllOf';
import type { NotificationListResponseNotificationsItemBasicInfoAllOfTwo } from './notificationListResponseNotificationsItemBasicInfoAllOfTwo';

export type NotificationListResponseNotificationsItemBasicInfo = NotificationListResponseNotificationsItemBasicInfoAllOf & NotificationListResponseNotificationsItemBasicInfoAllOfTwo;
